import React, { FC } from 'react';

import { useSession } from 'modules/Session';

import LoggedInActions from '../LoggedInActions';
import LoggedOutActions from '../LoggedOutActions';

const HeaderActions: FC = () => {
  const [isAuthenticated] = useSession();

  return isAuthenticated ? <LoggedInActions /> : <LoggedOutActions />;
};

export default HeaderActions;
